import React, { Suspense, useState, useRef } from "react";
import Header from "./Header";
import FileSection from "./FileSection";
import Footer from "./Footer";
import { BrowserRouter, Route } from "react-router-dom";
import DiagramPage from "./DiagramPage";
import "../i18n";
import "../assets/App.css";
import SelectPreprocessedData from "./SelectPreprocessedData";
import { FileStore } from "../stores/FileStore";
import CytoscapeGraph from "./CytoscapeGraph";
import PCAButton from "./PCAButton";
import PCAGraph from "./PCAGraph";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

const App = (props) => {

  const nonFilteredFiles = FileStore.useState((s) => s.nonFilteredFiles);
  const filteredFiles = FileStore.useState((s) => s.filteredFiles);

  const [uploadSectionOpen, setUploadSectionOpen] = useState(false);

  const uploadSectionRef = useRef(null);

  function openUploadSection() {
    setUploadSectionOpen(!uploadSectionOpen);
    setTimeout(() => {
      executeScroll();
    }, 100)
  };

  const executeScroll = () => uploadSectionRef.current.scrollIntoView({
    block: 'center',
    inline: 'center',
    behavior: 'smooth'
  });

  return (
    <div>
      <Suspense fallback={null}>
        <BrowserRouter>
          <div style={{ textAlign: "center" }}>
            <Route path={`${process.env.PUBLIC_URL}/`} exact>
              <div className="main">
              <Header />
	      {nonFilteredFiles.length !== 0 || filteredFiles.length !== 0 ? <FileSection /> : (
                <>
                  <div className="buttonSection">
                    <div style={{marginRight: "2%"}}>
                      <SelectPreprocessedData />
                    </div>
                    <Link to={`${process.env.PUBLIC_URL}/pca`} className="link">
                      <PCAButton />
                    </Link>
                    <button style={{marginLeft: "2%", padding: "0 3%"}} type="button" className="buttonContainer" onClick={openUploadSection}>
                      <i className="fas fa-upload" id="icon" style={{marginBottom: "5%"}}></i>
                      <p id="text" style={{padding: "0 2%"}}>{props.t("upload.geneset.files.button.name")} <span style={{fontSize: "14px"}}>(CSV/TSV)</span></p>
                    </button>
                  </div>
                  <div style={{ marginTop: "5%" }}></div>
                  <div style={{ paddingBottom: "5%" }} ref={uploadSectionRef}>
                    {uploadSectionOpen ? <FileSection /> : <></>}
                  </div>
                </>
                )}
              </div>
              
              <Footer />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/diagram`} exact>
              <DiagramPage />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/pathway-graph`} exact>
              <CytoscapeGraph />
            </Route>
            <Route path={`${process.env.PUBLIC_URL}/pca`} exact>
              <PCAGraph />
            </Route>
          </div>
        </BrowserRouter>
      </Suspense>
    </div>
  );
};

export default withTranslation()(App);
